import { BonusPeriodLiteModel, useGetBonusPeriods } from 'api-hooks/bonus';
import { Option } from 'baseui/select';
import CustomFormControl from 'components/elements/custom-form-control';
import Select from 'components/elements/master/select-input';
import useGenerateSelectProps from 'hooks/use-generate-select-props';
import * as React from 'react';

function transformer(item: BonusPeriodLiteModel): Option {
  return {
    id: item.id,
    label: item.name,
  };
}
export interface BonusPeriodSelectInputProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
}

export default function BonusPeriodSelectInput(
  props: BonusPeriodSelectInputProps,
) {
  const { label, placeholder, value, onSelected } = props;

  const query = useGetBonusPeriods({
    params: {
      limit: -1,
    },
  });

  const { options, value: _value } = useGenerateSelectProps({
    query,
    transformer,
    value,
  });

  return (
    <CustomFormControl label={label} noMargin={props.noMargin}>
      <Select
        type="select"
        placeholder={placeholder}
        options={options}
        value={_value}
        onChange={(params: any) => {
          onSelected?.(params?.option?.id);
        }}
      />
    </CustomFormControl>
  );
}
